import { useSelector } from 'react-redux';

// Единая точка чтения выбранной колоды: null, пока колода не выбрана
const useSelectedDeck = () => useSelector((state) => state.deck.selectedDeck);

export default useSelectedDeck;
